import "@/services/sentry";
import type { App } from "vue";
// import * as Sentry from "@sentry/vue";

import { initDevMocks } from "@/mocks/browser";
import { localesPlugin } from "@/locales/vue";
import { universalStorage } from "@/utils/universal-storage";
import { VueQueryPlugin } from "@tanstack/vue-query";

import PrimeVue from "primevue/config";
import { isBrowser } from "@/utils/platform";

// fixes issue where vue-i18n 9.3.0+ are missing the variable '__VUE_PROD_DEVTOOLS__' in the global scope
isBrowser() ? (window.__VUE_PROD_DEVTOOLS__ = false) : (global.__VUE_PROD_DEVTOOLS__ = false);

export default async (app: App) => {
  // if (isDeployed()) {
  //   Sentry.init({
  //     app,
  //     dsn: "https://5ee8000276f541a8918026fdbeb256df@o1086568.ingest.sentry.io/4505471249874944",
  //     environment: import.meta.env.APP_ENV,
  //     integrations: [
  //       new Sentry.BrowserTracing(),
  //       new Sentry.Replay({
  //         maskAllText: false,
  //         blockAllMedia: false,
  //       }),
  //     ],

  //     // Capture Replay for 10% of all sessions,
  //     // plus for 100% of sessions with an error
  //     replaysSessionSampleRate: 1.0,
  //     replaysOnErrorSampleRate: 1.0,
  //   });
  // }

  const lang = universalStorage.get("lang");
  if (lang) await localesPlugin(app, lang);
  app.use(PrimeVue);
  app.use(VueQueryPlugin, {
    queryClientConfig: {
      defaultOptions: {
        queries: {
          staleTime: 1000 * 60, // 1 minute
          cacheTime: 1000 * 60 * 5, // 5 minutes
          retry: 0, // we rely for retries through axios to make sure it works for all requests
        },
      },
    },
  });
  await initDevMocks();
};
